export function getUserEmail(): string | null {
  try {
    const raw = localStorage.getItem("_user");
    if (!raw) return null;
    const user = JSON.parse(raw);
    return user?.email ?? null;
  } catch {
    return null;
  }
}
